/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceMergedIntoSource } from './SourceMergedIntoSource';
import {
    SourceMergedIntoSourceFromJSON,
    SourceMergedIntoSourceFromJSONTyped,
    SourceMergedIntoSourceToJSON,
    SourceMergedIntoSourceToJSONTyped,
} from './SourceMergedIntoSource';
import type { SourceType } from './SourceType';
import {
    SourceTypeFromJSON,
    SourceTypeFromJSONTyped,
    SourceTypeToJSON,
    SourceTypeToJSONTyped,
} from './SourceType';
import type { SourceTag } from './SourceTag';
import {
    SourceTagFromJSON,
    SourceTagFromJSONTyped,
    SourceTagToJSON,
    SourceTagToJSONTyped,
} from './SourceTag';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
    SourceContactToJSONTyped,
} from './SourceContact';

/**
 * 
 * @export
 * @interface Source
 */
export interface Source {
    /**
     * 
     */
    id?: string;
    /**
     * ID of the surviving source after a merge, or null if this source has not been merged.
     */
    readonly merged_into?: string | null;
    /**
     * Whether this source has been soft-deleted.
     */
    readonly is_deleted?: boolean;
    /**
     * Surviving source this source was merged into. Absent when it was never merged.
     */
    readonly merged_into_source?: SourceMergedIntoSource;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    location?: string | null;
    /**
     * 
     */
    contacts?: Array<SourceContact>;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    npi_number?: string | null;
    /**
     * All fax numbers associated with this source.
     */
    fax_numbers?: Array<string>;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    tag_id?: string | null;
    /**
     * 
     */
    type?: SourceType;
    /**
     * 
     */
    tag?: SourceTag;
}



/**
 * Check if a given object implements the Source interface.
 */
export function instanceOfSource(value: object): value is Source {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SourceFromJSON(json: any): Source {
    return SourceFromJSONTyped(json, false);
}

export function SourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Source {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'merged_into': json['merged_into'] === undefined ? undefined : json['merged_into'] === null ? null : json['merged_into'],
        'is_deleted': json['is_deleted'] == null ? undefined : json['is_deleted'],
        'merged_into_source': json['merged_into_source'] == null ? undefined : SourceMergedIntoSourceFromJSON(json['merged_into_source']),
        'name': json['name'],
        'location': json['location'] === undefined ? undefined : json['location'] === null ? null : json['location'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(SourceContactFromJSON)),
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'npi_number': json['npi_number'] === undefined ? undefined : json['npi_number'] === null ? null : json['npi_number'],
        'fax_numbers': json['fax_numbers'] == null ? undefined : json['fax_numbers'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'tag_id': json['tag_id'] === undefined ? undefined : json['tag_id'] === null ? null : json['tag_id'],
        'type': json['type'] == null ? undefined : SourceTypeFromJSON(json['type']),
        'tag': json['tag'] == null ? undefined : SourceTagFromJSON(json['tag']),
    };
}

export function SourceToJSON(json: any): Source {
    return SourceToJSONTyped(json, false);
}

export function SourceToJSONTyped(value?: Omit<Source, 'merged_into'|'is_deleted'|'merged_into_source'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'location': value['location'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(SourceContactToJSON)),
        'phone': value['phone'],
        'npi_number': value['npi_number'],
        'fax_numbers': value['fax_numbers'],
        'email': value['email'],
        'tag_id': value['tag_id'],
        'type': SourceTypeToJSON(value['type']),
        'tag': SourceTagToJSON(value['tag']),
    };
}

